import { render, staticRenderFns } from "./FeedbackItemList.vue?vue&type=template&id=557d18cc&scoped=true"
import script from "./FeedbackItemList.vue?vue&type=script&lang=js"
export * from "./FeedbackItemList.vue?vue&type=script&lang=js"
import style0 from "./FeedbackItemList.vue?vue&type=style&index=0&id=557d18cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d18cc",
  null
  
)

export default component.exports